import m49 from "./m49.json";

// Factsheets are named by ISO3 (public/factsheets/ALB.html), while the app identifies the
// selected country by ISO2 and the deep link by ISO3 - so both directions are needed, plus
// the country name for the title when only the ISO3 from a URL is available.
const codes = m49.filter(
    (item) => item["ISO-alpha2 Code"] && item["ISO-alpha3 Code"]
);

export const iso2ToIso3 = Object.fromEntries(
    codes.map((item) => [
        item["ISO-alpha2 Code"].toUpperCase(),
        item["ISO-alpha3 Code"].toUpperCase(),
    ])
);

export const iso3ToIso2 = Object.fromEntries(
    codes.map((item) => [
        item["ISO-alpha3 Code"].toUpperCase(),
        item["ISO-alpha2 Code"].toUpperCase(),
    ])
);

export const iso3ToLabel = Object.fromEntries(
    codes.map((item) => [item["ISO-alpha3 Code"].toUpperCase(), item["Country or Area"]])
);

export const factsheetFileUrl = (iso3) =>
    iso3 ? `${process.env.PUBLIC_URL}/factsheets/${iso3.toUpperCase()}.html` : null;

export const factsheetUrlForCountryCode = (iso2) => {
    const iso3 = iso2 && iso2ToIso3[iso2.toUpperCase()];
    return iso3 ? factsheetFileUrl(iso3) : null;
};

// Shareable deep link. HashRouter, so the route lives after the '#' and the URL keeps
// working under the /agrifood-systems-data/ sub-path the app is deployed on.
export const factsheetShareUrl = (iso3) =>
    `${window.location.origin}${window.location.pathname}#/factsheet/${iso3.toUpperCase()}`;

// Only a handful of countries have a factsheet, and the app is served with an SPA
// fallback: a missing file answers 200 with index.html instead of a 404, so a HEAD
// check would always pass and the iframe would boot a second copy of the dashboard.
// Peek at the first chunk instead and reject the app shell.
export const factsheetExists = async (url, signal) => {
    const response = await fetch(url, { signal });
    if (!response.ok) return false;
    if (!response.body) return true;
    const reader = response.body.getReader();
    const { value } = await reader.read();
    reader.cancel();
    return !new TextDecoder().decode(value).includes('id="root"');
};

// Landing on an indicators URL is immediately followed by internal re-navigations - Sidebar
// normalises the path with the trailing scroll segment, and hydrating the country triggers
// handleRoute - and every navigate() call replaces the router state, so a request carried
// in location.state never survives to the card that has to act on it. A module-level
// request does, and is consumed once by the country it was meant for.
let pendingFactsheet = null;

export const requestFactsheet = (iso3) => {
    pendingFactsheet = iso3 ? iso3.toUpperCase() : null;
};

export const consumeFactsheetRequest = (iso3) => {
    if (!iso3 || pendingFactsheet !== iso3.toUpperCase()) return false;
    pendingFactsheet = null;
    return true;
};
